var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B3DD8460-7B53-446C-B3C6-E9209FAAB3A7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "portfolio-builder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.5-client-profile",
    transform: "translate(-99.000000, -361.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "work-area",
    transform: "translate(60.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "client-profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(16.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attributes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "performance"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(6.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "translate(17.000000, 118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/viewfinder/performance"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/performance"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(5.703704, 4.666667)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    fill: "#9DD47D",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.059097,3.31305234 L6.58451754,6.35261953 C6.48275895,6.41381952 6.38100036,6.49542605 6.29959349,6.57702604 C5.87221393,7.04623254 5.91290434,7.76022597 6.38100036,8.18865859 C6.84909638,8.61709121 7.56139998,8.5762651 7.98881862,8.10705859 L12.2016567,3.47622622 C12.2220084,3.43542622 12.2423602,3.39462622 12.2016567,3.35382622 C12.1812138,3.29265234 12.099807,3.29265234 12.059097,3.31305234 Z",
    id: "Shape",
    fill: "#FFFFFF",
    transform: "translate(9.114046, 5.893444) rotate(10.000000) translate(-9.114046, -5.893444) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15808914,5.64494145 C2.83206345,3.68877441 4.83439746,2.26994153 7.19953912,2.26994153 C9.11083491,2.26994153 10.7852019,3.19649979 11.7130887,4.58442251",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    strokeWidth: 4.44444444,
    strokeDasharray: "0.8888888597488404,2.666666793823242",
    fillRule: "nonzero",
    transform: "translate(7.058089, 4.019942) rotate(2.000000) translate(-7.058089, -4.019942) "
  })))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPerformance);
export default __webpack_public_path__ + "static/media/view_performance.9c148fb24d0553340760a15f588b1e2e.svg";
export { ForwardRef as ReactComponent };